import { NavigationType } from 'react-router';

/**
 * Click-away handling must distinguish a panel-external click from a click on
 * a bell that intentionally toggles that same panel.
 */
export const NOTIFICATION_TOGGLE_SELECTOR = '[data-notification-toggle="true"]';

/**
 * [MCV-1753] react-router `state` a notification row's link carries. The vault page-sync hook
 * (routing/useVaultPageSync.ts) reads it to refetch the destination even when the click lands on
 * the page already on screen. NavEntry also passes a string `state`, hence the object check.
 */
export const NOTIFICATION_NAVIGATION_STATE = { fromNotification: true } as const;
export const isNotificationNavigation = (state: unknown): boolean =>
  typeof state === 'object' &&
  state !== null &&
  (state as { fromNotification?: unknown }).fromNotification === true;

/**
 * A history entry keeps its `state`, so back/forward and the first render after a reload carry
 * `fromNotification` from a click made long before. Only the click itself is an arrival: a PUSH, or
 * a REPLACE when the row points at the page already on screen. A POP never is.
 */
export const isNotificationArrival = (state: unknown, navigationType: NavigationType): boolean =>
  navigationType !== NavigationType.Pop && isNotificationNavigation(state);
